module.exports = __webpack_public_path__ + "static/recording-voiceover-e4c0709a74ad226c186e6a3795be528f.png";